<template>
    <v-container>
        <HTMLCard :htmlToDisplay="htmlHeader" />
        <v-row v-if="getBookmarkedServices && getBookmarkedServices.length > 0" class="bookmarks" justify="center">
            <v-col md="6">
                <v-row>
                    <v-col v-for="(service, index) in getBookmarkedServices" :key="index" cols="12" sm="6">
                        <v-card @click="selectService(service)" class="service">
                            <v-icon class="bookmark" @click.stop.prevent="bookmark(service.name)">mdi-star-outline</v-icon>
                            <v-card-title>{{ getServiceTitle(service.name) }}</v-card-title>
                            <v-card-subtitle>{{ getServiceTitle(service.name, 'subtitle') }}</v-card-subtitle>
                            <v-icon class="icon-service">{{ getServiceIcon(service.name) }}</v-icon>
                            <v-icon class="goto">mdi-chevron-right</v-icon>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="getServices && getServices.length > 0" justify="center">
            <v-col md="6">
                <v-row>
                    <v-col v-for="(service, index) in getServices" :key="index" cols="12" sm="6">
                        <v-card @click="selectService(service)" class="service">
                            <v-icon class="bookmark" @click.stop.prevent="bookmark(service.name)">mdi-star-outline</v-icon>
                            <v-card-title>{{ getServiceTitle(service.name) }}</v-card-title>
                            <v-card-subtitle>{{ getServiceTitle(service.name, 'subtitle') }}</v-card-subtitle>
                            <v-icon class="icon-service">{{ getServiceIcon(service.name) }}</v-icon>
                            <v-icon class="goto">mdi-chevron-right</v-icon>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <HTMLCard :htmlToDisplay="htmlFooter" />
    </v-container>
</template>

<script>
import { api } from '@/utils/api';
import HTMLCard from '../components/HTMLCard.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
    components: {
        HTMLCard
    },
    async mounted() {
        this.resetIframeServices(null, null, null);
        await this.getBookmarkedClients();
        if (this.getServices.length + this.getBookmarkedServices.length === 1) {
            const service = this.getServices.length > 0 ? this.getServices[0] : this.getBookmarkedServices[0];
            this.selectService(service);
        }
    },
    methods: {
        ...mapMutations(['setServiceBookmark', 'setServicesBookmarks']),
        async getBookmarkedClients() {
            if (this.clientId) {
                const bookmarkedClients = await api.get(['bookmarks', 'getBookmarkedServices'], { clientId: this.clientId });
                this.setServicesBookmarks({ clientId: this.clientId, servicesBookmarks: bookmarkedClients });
            }
        },
        async selectService(service) {
            const name = service.name;
            if (service?.url) {
                window.open(service.url, '_blank');
            } else if (service?.requires_auth) {
                this.$store.commit('setClientService', service);
                this.$store.commit('setCurrentDocsPortlet', service.id);
                const redirectLink = api._buildURL(
                    ['docs', 'authenticate'],
                    {
                        client: this.$store.getters.getClientName,
                        clientId: this.$store.getters.getCurrentClientId,
                        portletId: service.id
                    },
                    'docs'
                );
                if (redirectLink) {
                    window.location.href = redirectLink;
                }
            } else if (service.name.includes('IFRAME')) {
                this.resetIframeServices('IFRAME', service.serviceNumber, service.instance[this.$store.getters.getCurrentClientId]);
                this.$router.push(
                    `/${this.$store.getters.getClientName}${this.$store.getters.getServiceRoutes[0].url}/${service.serviceNumber}`
                );
            } else {
                this.$store.commit('setClientService', name);
                this.$router.push(`/${this.$store.getters.getClientName}${this.$store.getters.getServiceRoutes[0].url}`);
            }
        },
        resetIframeServices(iframe, serviceNumber, instances) {
            this.$store.commit('setClientService', iframe);
            this.$store.commit('setIframeServiceNumber', serviceNumber);
            this.$store.commit('setAutorizedIframeInstances', instances);
        },
        getServiceTitle(name, item = 'title') {
            let id = `services.${this.clientId}.${name}.${item}`;
            let translate = this.$te(id) && this.$t(id);
            if (translate) return translate;
            id = `services.default.${name}.${item}`;
            translate = this.$t(id);
            if (translate !== id) return translate;
            if (typeof name === 'object') return name.service_name;
            return name;
        },
        getServiceIcon(name) {
            const mapServiceNameVsTitle = {
                trackandtrace: 'mdi-package-variant',
                bpm: 'mdi-chart-arc',
                bi: 'mdi-chart-arc',
                docs: 'mdi-file-tree',
                genericsearch: 'mdi-file-search',
                deliveries: 'mdi-truck-delivery',
                'os pdf export': 'mdi-file-tree',
                default: 'mdi-window-restore',
                iframe: 'mdi-application-braces-outline'
            };
            return (
                (name.includes('IFRAME') && mapServiceNameVsTitle.iframe) ||
                mapServiceNameVsTitle[name.toLowerCase()] ||
                mapServiceNameVsTitle.default
            );
        },
        async bookmark(id) {
            this.setServiceBookmark(id);
            if (this.servicesBookmarks && this.servicesBookmarks[this.getCurrentClientId]) {
                await api.post(
                    ['bookmarks', 'toggleBookmarkService'],
                    null,
                    { clientId: this.getCurrentClientId, servicesBookmarks: this.servicesBookmarks[this.getCurrentClientId] },
                    null
                );
            }
        }
    },
    computed: {
        ...mapGetters(['getBookmarkedServices', 'getServices', 'getCurrentClientId']),
        ...mapState({
            clientId: state => state.clients.current,
            servicesBookmarks: state => state.clients.servicesBookmarks
        }),
        htmlHeader: function () {
            return this.$store.getters.getServiceHeader;
        },
        htmlFooter: function () {
            return this.$store.getters.getServiceFooter;
        }
    },
    watch: {
        clientId: function (newValue) {
            this.getBookmarkedClients();
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
.bookmarks {
    margin-bottom: 30px;
    .bookmark {
        color: $yellow !important;
    }
}
.service {
    cursor: pointer;
    border-top: 7px solid #fff;
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
    .bookmark {
        color: $lighter-grey;
        position: absolute;
        right: 10px;
        top: 20px;
        height: 24px;
        width: 24px;
        &:hover {
            color: $yellow;
        }
    }
    .icon-service {
        color: $lighter-grey;
        margin: 0 16px 20px;
        height: 24px;
        width: 24px;
    }
}
</style>
